import { getContentById } from '@/app/lib/wordpress'
import React, { useEffect, useState } from 'react'
import sanitizeHtml from 'sanitize-html'

export default function Testimonial({id}) {

  const [testimonial, setTestimonial] = useState()

  useEffect(() => {
    async function getTestimonial() {

      const currentTestimonial = await getContentById("testimonials", id)
      setTestimonial(currentTestimonial)
    } 
    getTestimonial()
  }, [])

  return (
    <div>
      <div className="text-lg italic leading-loose mt-12 text-center" dangerouslySetInnerHTML={{ __html: sanitizeHtml(testimonial?.content?.rendered) }} />
      <div className="font-bold mt-8 text-center">
        {testimonial?.acf?.testimonial_first_name} {testimonial?.acf?.testimonial_last_name}
      </div>
      <div className="text-base text-center">{testimonial?.acf?.testimonial_work_title}</div>
    </div>
  )
}
